//
export interface Route {
  name: string;
}
export interface IBreadcrumbItem {
  title: string;
  route: Route;
  copy(): IBreadcrumbItem;
}
export class BreadcrumbItem implements IBreadcrumbItem {
  constructor(public title: string, public route: Route) {}
  copy() {
    return new BreadcrumbItem(this.title, this.route);
  }
}
